import React, { createElement } from 'react';
import { render } from 'react-dom';
import { NotificationContainer } from 'react-notifications';
import { WRCThemeProvider } from 'webdep-react-controls';
import THEME from 'Constants/theme';

/**
 * Function render component in container element with props in container 'data' attribute
 * @param {*} componentFn Root component of page
 * @param {*} container Dom element with component props in 'data' attribute
 */
function renderComponent(componentFn, container = document.getElementById('react-root')) {
  if (!container) {
    return;
  }
  const props = JSON.parse(container.getAttribute('data'));
  render(
    (
      <WRCThemeProvider theme={THEME}>
        {createElement(componentFn, props)}
        <NotificationContainer />
      </WRCThemeProvider>
    ),
    container,
  );
}

export default renderComponent;
